export enum RolesEnum {
    Worker = 10,
    FarmAdmin = 100,
    CompanyAdmin = 1000,
}
